import { site } from '@yola/ws-sdk';
import { BINDING_ATTRIBUTE } from 'src/js/modules/bindings/constants/attributes';
import linkTypes from '../constants/link-types';
import fieldNames from '../constants/field-names';

const getBindingFieldsValues = (linkElement) => {
  const bindingId = linkElement?.getAttribute(BINDING_ATTRIBUTE);

  if (!bindingId) {
    return {};
  }

  const activePageId = site.accessors.getActivePageId();
  const binding =
    site.accessors.getPageBindings(activePageId).find(({ id }) => id === bindingId) || null;

  if (!binding) {
    return {};
  }

  return {
    [fieldNames.LINK_TYPE]: linkTypes.BINDING,
    [fieldNames.BINDING_SLUG]: binding.slug,
    [fieldNames.BINDING_ID]: bindingId,
  };
};

export default getBindingFieldsValues;
